const FEATURES = [
  { name: 'Mapa natal visual completo',        free: true,  paid: true  },
  { name: 'Interpretação do Sol',              free: true,  paid: true  },
  { name: 'Interpretação da Lua',              free: true,  paid: true  },
  { name: 'Interpretação do Ascendente',       free: true,  paid: true  },
  { name: '8 planetas restantes',              free: false, paid: true  },
  { name: '12 casas astrológicas',             free: false, paid: true  },
  { name: 'Aspectos planetários',              free: false, paid: true  },
  { name: 'Previsões personalizadas diárias',  free: false, paid: true  },
  { name: 'Previsões semanais e mensais',      free: false, paid: true  },
  { name: 'Sinastria entre mapas reais',       free: false, paid: true  },
  { name: 'Trânsitos planetários',             free: false, paid: true  },
  { name: 'Exportação PDF',                    free: false, paid: true  },
];

export function FeatureComparison() {
  return (
    <div style={{
      borderRadius: 'var(--radius-sm)',
      border:       '1px solid var(--line-soft)',
      overflow:     'hidden',
    }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: 'var(--bg-base)' }}>
            <th style={{ textAlign: 'left', padding: '0.75rem 1rem', fontSize: 'var(--text-label)', color: 'var(--text-secondary)', fontWeight: 600 }}>Funcionalidade</th>
            <th style={{ textAlign: 'center', padding: '0.75rem 0.5rem', fontSize: 'var(--text-label)', color: 'var(--text-secondary)', fontWeight: 600 }}>Grátis</th>
            <th style={{ textAlign: 'center', padding: '0.75rem 0.5rem', fontSize: 'var(--text-label)', color: 'var(--petrol)', fontWeight: 600 }}>Premium</th>
          </tr>
        </thead>
        <tbody>
          {FEATURES.map((f, i) => (
            <tr key={i} style={{ borderTop: '1px solid var(--line-soft)', background: i % 2 === 0 ? 'transparent' : 'var(--bg-elevated)' }}>
              <td style={{ padding: '0.6rem 1rem', fontSize: 'var(--text-caption)', color: 'var(--text-secondary)' }}>{f.name}</td>
              <td style={{ textAlign: 'center', padding: '0.6rem', fontSize: '1rem' }}>
                {f.free ? <span style={{ color: 'var(--petrol)' }}>✓</span> : <span style={{ color: 'var(--celeste-soft)' }}>×</span>}
              </td>
              <td style={{ textAlign: 'center', padding: '0.6rem', fontSize: '1rem' }}>
                <span style={{ color: 'var(--petrol)', fontWeight: 700 }}>✓</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
